function cov_1xb44p0n1p() {
  var path = "/app/src/components/long-term-content/utils.tsx";
  var hash = "78411bfa250b4559eccd44a1071f88e7f20e2753";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/utils.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 34
        },
        end: {
          line: 12,
          column: 38
        }
      },
      "1": {
        start: {
          line: 13,
          column: 16
        },
        end: {
          line: 13,
          column: 20
        }
      },
      "2": {
        start: {
          line: 15,
          column: 23
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "3": {
        start: {
          line: 22,
          column: 15
        },
        end: {
          line: 22,
          column: 71
        }
      },
      "4": {
        start: {
          line: 24,
          column: 2
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "5": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 43
        }
      },
      "6": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 51
        }
      },
      "7": {
        start: {
          line: 31,
          column: 43
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "8": {
        start: {
          line: 35,
          column: 18
        },
        end: {
          line: 35,
          column: 56
        }
      },
      "9": {
        start: {
          line: 36,
          column: 16
        },
        end: {
          line: 36,
          column: 35
        }
      },
      "10": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 38
        }
      },
      "11": {
        start: {
          line: 66,
          column: 18
        },
        end: {
          line: 66,
          column: 56
        }
      },
      "12": {
        start: {
          line: 67,
          column: 16
        },
        end: {
          line: 67,
          column: 35
        }
      },
      "13": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 71,
          column: 3
        }
      },
      "14": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 70,
          column: 47
        }
      },
      "15": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 76,
          column: 17
        }
      },
      "16": {
        start: {
          line: 78,
          column: 2
        },
        end: {
          line: 182,
          column: 3
        }
      },
      "17": {
        start: {
          line: 80,
          column: 28
        },
        end: {
          line: 80,
          column: 74
        }
      },
      "18": {
        start: {
          line: 81,
          column: 33
        },
        end: {
          line: 81,
          column: 76
        }
      },
      "19": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 92,
          column: 7
        }
      },
      "20": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 91,
          column: 10
        }
      },
      "21": {
        start: {
          line: 89,
          column: 28
        },
        end: {
          line: 89,
          column: 60
        }
      },
      "22": {
        start: {
          line: 94,
          column: 6
        },
        end: {
          line: 104,
          column: 7
        }
      },
      "23": {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 103,
          column: 10
        }
      },
      "24": {
        start: {
          line: 101,
          column: 28
        },
        end: {
          line: 101,
          column: 60
        }
      },
      "25": {
        start: {
          line: 106,
          column: 6
        },
        end: {
          line: 116,
          column: 7
        }
      },
      "26": {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 115,
          column: 10
        }
      },
      "27": {
        start: {
          line: 113,
          column: 28
        },
        end: {
          line: 113,
          column: 60
        }
      },
      "28": {
        start: {
          line: 118,
          column: 6
        },
        end: {
          line: 128,
          column: 7
        }
      },
      "29": {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 127,
          column: 10
        }
      },
      "30": {
        start: {
          line: 125,
          column: 28
        },
        end: {
          line: 125,
          column: 60
        }
      },
      "31": {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 138,
          column: 8
        }
      },
      "32": {
        start: {
          line: 136,
          column: 26
        },
        end: {
          line: 136,
          column: 58
        }
      },
      "33": {
        start: {
          line: 141,
          column: 23
        },
        end: {
          line: 141,
          column: 46
        }
      },
      "34": {
        start: {
          line: 142,
          column: 33
        },
        end: {
          line: 142,
          column: 71
        }
      },
      "35": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 154,
          column: 7
        }
      },
      "36": {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 153,
          column: 10
        }
      },
      "37": {
        start: {
          line: 151,
          column: 28
        },
        end: {
          line: 151,
          column: 60
        }
      },
      "38": {
        start: {
          line: 156,
          column: 6
        },
        end: {
          line: 164,
          column: 8
        }
      },
      "39": {
        start: {
          line: 162,
          column: 26
        },
        end: {
          line: 162,
          column: 58
        }
      },
      "40": {
        start: {
          line: 167,
          column: 6
        },
        end: {
          line: 175,
          column: 8
        }
      },
      "41": {
        start: {
          line: 173,
          column: 26
        },
        end: {
          line: 173,
          column: 58
        }
      },
      "42": {
        start: {
          line: 177,
          column: 6
        },
        end: {
          line: 179,
          column: 7
        }
      },
      "43": {
        start: {
          line: 178,
          column: 8
        },
        end: {
          line: 178,
          column: 57
        }
      },
      "44": {
        start: {
          line: 181,
          column: 6
        },
        end: {
          line: 181,
          column: 49
        }
      },
      "45": {
        start: {
          line: 185,
          column: 43
        },
        end: {
          line: 186,
          column: 61
        }
      },
      "46": {
        start: {
          line: 186,
          column: 2
        },
        end: {
          line: 186,
          column: 61
        }
      },
      "47": {
        start: {
          line: 186,
          column: 28
        },
        end: {
          line: 186,
          column: 59
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 15,
            column: 23
          },
          end: {
            line: 15,
            column: 24
          }
        },
        loc: {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 31,
            column: 43
          },
          end: {
            line: 31,
            column: 44
          }
        },
        loc: {
          start: {
            line: 34,
            column: 14
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 34
      },
      "2": {
        name: "getFeesDescription",
        decl: {
          start: {
            line: 56,
            column: 16
          },
          end: {
            line: 56,
            column: 34
          }
        },
        loc: {
          start: {
            line: 65,
            column: 10
          },
          end: {
            line: 183,
            column: 1
          }
        },
        line: 65
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 89,
            column: 22
          },
          end: {
            line: 89,
            column: 23
          }
        },
        loc: {
          start: {
            line: 89,
            column: 28
          },
          end: {
            line: 89,
            column: 60
          }
        },
        line: 89
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 101,
            column: 22
          },
          end: {
            line: 101,
            column: 23
          }
        },
        loc: {
          start: {
            line: 101,
            column: 28
          },
          end: {
            line: 101,
            column: 60
          }
        },
        line: 101
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 113,
            column: 22
          },
          end: {
            line: 113,
            column: 23
          }
        },
        loc: {
          start: {
            line: 113,
            column: 28
          },
          end: {
            line: 113,
            column: 60
          }
        },
        line: 113
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 125,
            column: 22
          },
          end: {
            line: 125,
            column: 23
          }
        },
        loc: {
          start: {
            line: 125,
            column: 28
          },
          end: {
            line: 125,
            column: 60
          }
        },
        line: 125
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 136,
            column: 20
          },
          end: {
            line: 136,
            column: 21
          }
        },
        loc: {
          start: {
            line: 136,
            column: 26
          },
          end: {
            line: 136,
            column: 58
          }
        },
        line: 136
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 151,
            column: 22
          },
          end: {
            line: 151,
            column: 23
          }
        },
        loc: {
          start: {
            line: 151,
            column: 28
          },
          end: {
            line: 151,
            column: 60
          }
        },
        line: 151
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 162,
            column: 20
          },
          end: {
            line: 162,
            column: 21
          }
        },
        loc: {
          start: {
            line: 162,
            column: 26
          },
          end: {
            line: 162,
            column: 58
          }
        },
        line: 162
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 173,
            column: 20
          },
          end: {
            line: 173,
            column: 21
          }
        },
        loc: {
          start: {
            line: 173,
            column: 26
          },
          end: {
            line: 173,
            column: 58
          }
        },
        line: 173
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 185,
            column: 43
          },
          end: {
            line: 185,
            column: 44
          }
        },
        loc: {
          start: {
            line: 186,
            column: 2
          },
          end: {
            line: 186,
            column: 61
          }
        },
        line: 186
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 186,
            column: 20
          },
          end: {
            line: 186,
            column: 21
          }
        },
        loc: {
          start: {
            line: 186,
            column: 28
          },
          end: {
            line: 186,
            column: 59
          }
        },
        line: 186
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 26,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 11
          },
          end: {
            line: 25,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 25,
            column: 28
          },
          end: {
            line: 25,
            column: 35
          }
        }, {
          start: {
            line: 25,
            column: 38
          },
          end: {
            line: 25,
            column: 42
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 9
          },
          end: {
            line: 28,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 28,
            column: 31
          },
          end: {
            line: 28,
            column: 38
          }
        }, {
          start: {
            line: 28,
            column: 41
          },
          end: {
            line: 28,
            column: 50
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 38,
            column: 9
          },
          end: {
            line: 38,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 38,
            column: 9
          },
          end: {
            line: 38,
            column: 14
          }
        }, {
          start: {
            line: 38,
            column: 18
          },
          end: {
            line: 38,
            column: 37
          }
        }],
        line: 38
      },
      "4": {
        loc: {
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 69
      },
      "5": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 76,
            column: 17
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 75,
            column: 8
          },
          end: {
            line: 75,
            column: 49
          }
        }, {
          start: {
            line: 76,
            column: 8
          },
          end: {
            line: 76,
            column: 17
          }
        }],
        line: 74
      },
      "6": {
        loc: {
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 74,
            column: 4
          },
          end: {
            line: 74,
            column: 23
          }
        }, {
          start: {
            line: 74,
            column: 27
          },
          end: {
            line: 74,
            column: 32
          }
        }],
        line: 74
      },
      "7": {
        loc: {
          start: {
            line: 78,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 79,
            column: 4
          },
          end: {
            line: 139,
            column: 5
          }
        }, {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 165,
            column: 5
          }
        }, {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 175,
            column: 8
          }
        }, {
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 181,
            column: 49
          }
        }],
        line: 78
      },
      "8": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 92,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 92,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 82
      },
      "9": {
        loc: {
          start: {
            line: 94,
            column: 6
          },
          end: {
            line: 104,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 6
          },
          end: {
            line: 104,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 94
      },
      "10": {
        loc: {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 116,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 116,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 106
      },
      "11": {
        loc: {
          start: {
            line: 106,
            column: 10
          },
          end: {
            line: 106,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 106,
            column: 10
          },
          end: {
            line: 106,
            column: 32
          }
        }, {
          start: {
            line: 106,
            column: 36
          },
          end: {
            line: 106,
            column: 54
          }
        }],
        line: 106
      },
      "12": {
        loc: {
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 128,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 6
          },
          end: {
            line: 128,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 118
      },
      "13": {
        loc: {
          start: {
            line: 118,
            column: 10
          },
          end: {
            line: 118,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 118,
            column: 10
          },
          end: {
            line: 118,
            column: 32
          }
        }, {
          start: {
            line: 118,
            column: 36
          },
          end: {
            line: 118,
            column: 54
          }
        }],
        line: 118
      },
      "14": {
        loc: {
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 154,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 154,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 144
      },
      "15": {
        loc: {
          start: {
            line: 177,
            column: 6
          },
          end: {
            line: 179,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 177,
            column: 6
          },
          end: {
            line: 179,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 177
      },
      "16": {
        loc: {
          start: {
            line: 177,
            column: 10
          },
          end: {
            line: 177,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 10
          },
          end: {
            line: 177,
            column: 29
          }
        }, {
          start: {
            line: 177,
            column: 33
          },
          end: {
            line: 177,
            column: 38
          }
        }],
        line: 177
      },
      "17": {
        loc: {
          start: {
            line: 186,
            column: 28
          },
          end: {
            line: 186,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 186,
            column: 53
          },
          end: {
            line: 186,
            column: 55
          }
        }, {
          start: {
            line: 186,
            column: 58
          },
          end: {
            line: 186,
            column: 59
          }
        }],
        line: 186
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0, 0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "78411bfa250b4559eccd44a1071f88e7f20e2753"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1xb44p0n1p = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1xb44p0n1p();
import React from 'react';
import { Currency } from 'src/components/currency';
import { COUNTRY_NAME_BY_CURRENCY_MAP } from 'src/constants/country-name-by-currency-map';
import { getFormattedAmount } from 'src/utils/get-formatted-amount';
var PROCESSING_FEE_PERCENTAGE = (cov_1xb44p0n1p().s[0]++, 1.15);
var FEE_CAP = (cov_1xb44p0n1p().s[1]++, 57.5);
cov_1xb44p0n1p().s[2]++;
var getAdjustedFee = function getAdjustedFee(_ref) {
  var fullAmount = _ref.fullAmount,
    totalFees = _ref.totalFees;
  cov_1xb44p0n1p().f[0]++;
  var fees = (cov_1xb44p0n1p().s[3]++, Math.round(fullAmount * PROCESSING_FEE_PERCENTAGE) / 100);
  cov_1xb44p0n1p().s[4]++;
  if (totalFees > fees) {
    cov_1xb44p0n1p().b[0][0]++;
    cov_1xb44p0n1p().s[5]++;
    return fees > FEE_CAP ? (cov_1xb44p0n1p().b[1][0]++, FEE_CAP) : (cov_1xb44p0n1p().b[1][1]++, fees);
  } else {
    cov_1xb44p0n1p().b[0][1]++;
  }
  cov_1xb44p0n1p().s[6]++;
  return totalFees > FEE_CAP ? (cov_1xb44p0n1p().b[2][0]++, FEE_CAP) : (cov_1xb44p0n1p().b[2][1]++, totalFees);
};
cov_1xb44p0n1p().s[7]++;
var shouldShowProcessingFeeDescription = function shouldShowProcessingFeeDescription(currency, paymentsCount) {
  cov_1xb44p0n1p().f[1]++;
  var country = (cov_1xb44p0n1p().s[8]++, COUNTRY_NAME_BY_CURRENCY_MAP[currency]);
  var isKSA = (cov_1xb44p0n1p().s[9]++, country === 'saudi');
  cov_1xb44p0n1p().s[10]++;
  return (cov_1xb44p0n1p().b[3][0]++, isKSA) && (cov_1xb44p0n1p().b[3][1]++, paymentsCount === 4);
};
export function getFeesDescription(_ref2) {
  var serviceFeePolicy = _ref2.serviceFeePolicy,
    totalFees = _ref2.totalFees,
    feesAmount = _ref2.feesAmount,
    _currency = _ref2.currency,
    fullAmount = _ref2.fullAmount,
    paymentsCount = _ref2.paymentsCount,
    period = _ref2.period,
    t = _ref2.t;
  cov_1xb44p0n1p().f[2]++;
  var country = (cov_1xb44p0n1p().s[11]++, COUNTRY_NAME_BY_CURRENCY_MAP[_currency]);
  var isPi4 = (cov_1xb44p0n1p().s[12]++, paymentsCount === 4);
  cov_1xb44p0n1p().s[13]++;
  if (!feesAmount) {
    cov_1xb44p0n1p().b[4][0]++;
    cov_1xb44p0n1p().s[14]++;
    return t('paid_plans.no_interest_no_fees');
  } else {
    cov_1xb44p0n1p().b[4][1]++;
  }
  var fees = (cov_1xb44p0n1p().s[15]++, (cov_1xb44p0n1p().b[6][0]++, country === 'saudi') && (cov_1xb44p0n1p().b[6][1]++, isPi4) ? (cov_1xb44p0n1p().b[5][0]++, getAdjustedFee({
    fullAmount: fullAmount,
    totalFees: totalFees
  })) : (cov_1xb44p0n1p().b[5][1]++, totalFees));
  cov_1xb44p0n1p().s[16]++;
  switch (serviceFeePolicy) {
    case 'overall':
      cov_1xb44p0n1p().b[7][0]++;
      {
        var feePerPayment = (cov_1xb44p0n1p().s[17]++, Math.floor(fees / paymentsCount * 100) / 100);
        var formattedFeeAmount = (cov_1xb44p0n1p().s[18]++, getFormattedAmount(feePerPayment, _currency));
        cov_1xb44p0n1p().s[19]++;
        if (shouldShowProcessingFeeDescription(_currency, paymentsCount)) {
          cov_1xb44p0n1p().b[8][0]++;
          cov_1xb44p0n1p().s[20]++;
          return t('includes_amount_montlhy_processing_fee', {
            serviceFee: formattedFeeAmount
          }, {
            currency: function currency() {
              cov_1xb44p0n1p().f[3]++;
              cov_1xb44p0n1p().s[21]++;
              return /*#__PURE__*/React.createElement(Currency, {
                currency: _currency
              });
            }
          });
        } else {
          cov_1xb44p0n1p().b[8][1]++;
        }
        cov_1xb44p0n1p().s[22]++;
        if (period.size === 'month') {
          cov_1xb44p0n1p().b[9][0]++;
          cov_1xb44p0n1p().s[23]++;
          return t('includes_amount_montlhy_fee', {
            serviceFee: formattedFeeAmount
          }, {
            currency: function currency() {
              cov_1xb44p0n1p().f[4]++;
              cov_1xb44p0n1p().s[24]++;
              return /*#__PURE__*/React.createElement(Currency, {
                currency: _currency
              });
            }
          });
        } else {
          cov_1xb44p0n1p().b[9][1]++;
        }
        cov_1xb44p0n1p().s[25]++;
        if ((cov_1xb44p0n1p().b[11][0]++, period.size === 'week') && (cov_1xb44p0n1p().b[11][1]++, period.value === 1)) {
          cov_1xb44p0n1p().b[10][0]++;
          cov_1xb44p0n1p().s[26]++;
          return t('includes_amount_weekly_fee', {
            serviceFee: formattedFeeAmount
          }, {
            currency: function currency() {
              cov_1xb44p0n1p().f[5]++;
              cov_1xb44p0n1p().s[27]++;
              return /*#__PURE__*/React.createElement(Currency, {
                currency: _currency
              });
            }
          });
        } else {
          cov_1xb44p0n1p().b[10][1]++;
        }
        cov_1xb44p0n1p().s[28]++;
        if ((cov_1xb44p0n1p().b[13][0]++, period.size === 'week') && (cov_1xb44p0n1p().b[13][1]++, period.value === 2)) {
          cov_1xb44p0n1p().b[12][0]++;
          cov_1xb44p0n1p().s[29]++;
          return t('includes_amount_bi_weekly_fee', {
            serviceFee: formattedFeeAmount
          }, {
            currency: function currency() {
              cov_1xb44p0n1p().f[6]++;
              cov_1xb44p0n1p().s[30]++;
              return /*#__PURE__*/React.createElement(Currency, {
                currency: _currency
              });
            }
          });
        } else {
          cov_1xb44p0n1p().b[12][1]++;
        }
        cov_1xb44p0n1p().s[31]++;
        return t('paid_plans.service_fee_in_total', {
          serviceFee: feesAmount
        }, {
          currency: function currency() {
            cov_1xb44p0n1p().f[7]++;
            cov_1xb44p0n1p().s[32]++;
            return /*#__PURE__*/React.createElement(Currency, {
              currency: _currency
            });
          }
        });
      }
    case 'downpayment_only':
      cov_1xb44p0n1p().b[7][1]++;
      {
        var feeValue = (cov_1xb44p0n1p().s[33]++, Number(fees.toFixed(2)));
        var _formattedFeeAmount = (cov_1xb44p0n1p().s[34]++, getFormattedAmount(feeValue, _currency));
        cov_1xb44p0n1p().s[35]++;
        if (shouldShowProcessingFeeDescription(_currency, paymentsCount)) {
          cov_1xb44p0n1p().b[14][0]++;
          cov_1xb44p0n1p().s[36]++;
          return t('one_time_processing_fee', {
            serviceFee: _formattedFeeAmount
          }, {
            currency: function currency() {
              cov_1xb44p0n1p().f[8]++;
              cov_1xb44p0n1p().s[37]++;
              return /*#__PURE__*/React.createElement(Currency, {
                currency: _currency
              });
            }
          });
        } else {
          cov_1xb44p0n1p().b[14][1]++;
        }
        cov_1xb44p0n1p().s[38]++;
        return t('plus_one_time_upfront_service_fee', {
          serviceFee: feesAmount
        }, {
          currency: function currency() {
            cov_1xb44p0n1p().f[9]++;
            cov_1xb44p0n1p().s[39]++;
            return /*#__PURE__*/React.createElement(Currency, {
              currency: _currency
            });
          }
        });
      }
    case 'per_installment':
      cov_1xb44p0n1p().b[7][2]++;
      cov_1xb44p0n1p().s[40]++;
      return t('paid_plans.service_fee_in_total', {
        serviceFee: feesAmount
      }, {
        currency: function currency() {
          cov_1xb44p0n1p().f[10]++;
          cov_1xb44p0n1p().s[41]++;
          return /*#__PURE__*/React.createElement(Currency, {
            currency: _currency
          });
        }
      });
    default:
      cov_1xb44p0n1p().b[7][3]++;
      cov_1xb44p0n1p().s[42]++;
      if ((cov_1xb44p0n1p().b[16][0]++, country === 'saudi') && (cov_1xb44p0n1p().b[16][1]++, isPi4)) {
        cov_1xb44p0n1p().b[15][0]++;
        cov_1xb44p0n1p().s[43]++;
        return t('no_interest_processing_fee_may_apply');
      } else {
        cov_1xb44p0n1p().b[15][1]++;
      }
      cov_1xb44p0n1p().s[44]++;
      return t('paid_plans.no_interest_no_fees');
  }
}
cov_1xb44p0n1p().s[45]++;
export var getSortedInstallmentsOffers = function getSortedInstallmentsOffers(installments) {
  cov_1xb44p0n1p().f[11]++;
  cov_1xb44p0n1p().s[46]++;
  return installments.sort(function (a) {
    cov_1xb44p0n1p().f[12]++;
    cov_1xb44p0n1p().s[47]++;
    return a.subventionCampaignId ? (cov_1xb44p0n1p().b[17][0]++, -1) : (cov_1xb44p0n1p().b[17][1]++, 1);
  });
};